import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

/** Attaches the configured API key to every outbound HTTP request. */
export const apiKeyInterceptor: HttpInterceptorFn = (req, next) => {
  const apiKey = environment.apiKey;
  if (!apiKey) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        'X-Api-Key': apiKey,
      },
    }),
  );
};
